export const LoginText = 'Login';
export const GRIGOText = 'GRIGO';
export const SubmitText = 'Submit';
export const SignUpText = 'Sign Up';
export const AlreadyHaveAcc = 'Already have an Account?';
export const DontHaveAcc = "Don't have an Account?";
export const GoToApp = "Let's go to the app!";
export const WelcomeText = 'Please Enter Your Details';
export const InviteText = 'We invite you to join us today..';
export const SessionTimeout = 'Session Timeout';
export const SessionExpired = 'Your session has expired. Logging you out...';
export const ForgotPasswordText = 'Forgot Password';
export const ForgotPasswordInfo =
  'To reset your password, please enter your registered email address.';
export const BackToLogin = 'Know your password?';
export const WelcomeLabelText = 'Welcome Back!';
export const TaglineText = 'Get Started for Smarter';
export const AIInteractionsText = 'AI Interactions';
export const RegisteredText = "Don't have a company register yet?";
